export class TranslatedError extends Error {}
